export { TINForm } from './TINForm';
